import type { AgencyCategory } from '@saaga/shared/interfaces/agencies.interface'
import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import type { AgencyFormSchemaType } from './agency-form.schema'
import { AgencyFormCategoriesSection } from './form-sections/agency-form-categories-section.atom'
import { AgencyFormDescriptionsSection } from './form-sections/agency-form-descriptions-section.atom'
import { AgencyFormIdentitySection } from './form-sections/agency-form-identity-section.atom'
import { AgencyFormLongDescriptionSection } from './form-sections/agency-form-long-description-section.atom'

interface AgencyFormPresentationTabProps {
  form: UseFormReturn<AgencyFormSchemaType>
  categoryList: AgencyCategory[]
  logoPreviewUrl: string | null
  onLogoChange: (file: File | null) => void
  onLogoRemove: () => void
  isDisabled?: boolean
}

export const AgencyFormPresentationTab = ({
  form,
  categoryList,
  logoPreviewUrl,
  onLogoChange,
  onLogoRemove,
  isDisabled = false,
}: AgencyFormPresentationTabProps): ReactNode => (
  <div className="space-y-6">
    <AgencyFormIdentitySection
      form={form}
      logoPreviewUrl={logoPreviewUrl}
      onLogoChange={onLogoChange}
      onLogoRemove={onLogoRemove}
      isDisabled={isDisabled}
    />
    <AgencyFormDescriptionsSection form={form} isDisabled={isDisabled} />
    <AgencyFormCategoriesSection form={form} categoryList={categoryList} isDisabled={isDisabled} />
    <AgencyFormLongDescriptionSection form={form} isDisabled={isDisabled} />
  </div>
)

AgencyFormPresentationTab.displayName = 'AgencyFormPresentationTab'
